export type IAuthType = "signin" | "signup";

export interface ISignUpParams {
  readonly email: string;
  readonly password: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly timezone?: string;
  readonly website?: string;
  readonly ref?: string;
  readonly code?: string;
}

export class PreferredLoginError extends Error {
  public methods: string[] = [];

  constructor(message: string, methods: string[]) {
    super(message);
    this.methods = methods;
  }
}
